<div class="notifications-sidenav" [class.open]="sidebarStatus === NotificationsSidebarStatus.Open">
	<div class="type">
		<span [innerText]="'notification.type.volume' | translate"></span>
		<mat-icon class="filter" (click)="onFiltersClick()">filter_alt</mat-icon>
	</div>

	<div class="notification-list">
		@for (n of filteredVolumeNotifications; track n) {
		<div class="notification">
			<small>{{ n.date }}</small>
			{{ 'notification.volumeChange.intro' | translate }}
			<strong>{{ n.currency_name }}</strong>
			{{ 'notification.volumeChange.by' | translate }}
			<strong>{{ n.change }}%</strong>
			{{ 'notification.volumeChange.onInterval' | translate }}
			<strong>{{ n.interval_label }}</strong>
			{{ 'notification.volumeChange.fromVolume' | translate }}
			<strong>{{ n.prev_volume }}</strong>
			{{ 'notification.volumeChange.toVolume' | translate }}
			<strong>{{ n.curr_volume }}</strong>
			{{ 'notification.volumeChange.end' | translate }}
		</div>
		}
	</div>
</div>
